export const BREAKPOINT_SM_PX = 576;
export const BREAKPOINT_MD_PX = 768;
export const BREAKPOINT_LG_PX = 1024;
export const BREAKPOINT_XL_PX = 1280;

export const BP_SM = `(min-width: ${BREAKPOINT_SM_PX}px)`;
export const BP_MD = `(min-width: ${BREAKPOINT_MD_PX}px)`;
export const BP_LG = `(min-width: ${BREAKPOINT_LG_PX}px)`;
export const BP_XL = `(min-width: ${BREAKPOINT_XL_PX}px)`;

export const BP_DESKTOP = BP_LG;
